import angular from 'angular';

angular.module('cloudX').factory('checkEidConfiguration', [
  'checkTenantConfiguration',
  function(checkTenantConfiguration) {
    return function() {
      return checkTenantConfiguration('[1,3]');
    };
  },
]);
